import { useMutation } from "@tanstack/react-query";
import { updateEvent } from "../services/EventService";

export function useEventUpdate() {
    return useMutation({
        mutationFn: updateEvent,
    });
}
